export type BoardPresentation = Readonly<{
  defaultVisible: boolean;
  defaultEnabled: boolean;
  imageUrl: string | null;
}>;

export const EMPTY_BOARD_PRESENTATION: BoardPresentation = Object.freeze({
  defaultVisible: false,
  defaultEnabled: false,
  imageUrl: null,
});

/** 管理画面の公開設定を検証する。旧API・未設定の板は初期表示を許可しない。 */
export function parseBoardPresentation(value: unknown): BoardPresentation {
  if (typeof value !== "object" || value === null)
    return EMPTY_BOARD_PRESENTATION;
  const record = value as Record<string, unknown>;
  if (
    typeof record.defaultVisible !== "boolean" ||
    typeof record.defaultEnabled !== "boolean" ||
    !(
      record.imageUrl === null ||
      (typeof record.imageUrl === "string" &&
        /^https?:\/\//.test(record.imageUrl))
    )
  ) {
    return EMPTY_BOARD_PRESENTATION;
  }
  return Object.freeze({
    defaultVisible: record.defaultVisible,
    defaultEnabled: record.defaultEnabled,
    imageUrl: record.imageUrl,
  });
}

let presentation: Readonly<Record<string, BoardPresentation>> = Object.freeze(
  {},
);
const listeners = new Set<() => void>();

export function getBoardPresentations(): Readonly<
  Record<string, BoardPresentation>
> {
  return presentation;
}

export function subscribeBoardPresentations(listener: () => void): () => void {
  listeners.add(listener);
  return (): void => {
    listeners.delete(listener);
  };
}

export function syncBoardPresentations(
  boards: readonly Readonly<{
    slug: string;
    presentation?: BoardPresentation;
  }>[],
): void {
  presentation = Object.freeze(
    Object.fromEntries(
      boards.map((board) => [
        board.slug,
        parseBoardPresentation(board.presentation),
      ]),
    ),
  );
  for (const listener of listeners) listener();
}
